import { render, staticRenderFns } from "./threejs6.vue?vue&type=template&id=690495d8&scoped=true"
import script from "./threejs6.vue?vue&type=script&lang=js"
export * from "./threejs6.vue?vue&type=script&lang=js"
import style0 from "./threejs6.vue?vue&type=style&index=0&id=690495d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690495d8",
  null
  
)

export default component.exports